<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Division Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Name</label>
                <input type="text" class="form-control" id="division-name" v-model="dvs.name">
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../services/api'
import { division } from '../models/division'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatePicker from '../components/AppDatePicker.vue'
import AppNavBar from '../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
        return {
            dvs: {...division},
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const dvsApi = api('division')
            this.dvs = await dvsApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const dvsApi = api('division')
            if(this.$route.query.id !== undefined) {
                await dvsApi.update(this.dvs, this.$route.query.id)
            } else {
                await dvsApi.create(this.dvs)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
    }
}
</script>